import { useRouter } from "next/router";
import { getAlternateLocaleByCode } from "@common/types/Locale";
import { Button } from "@talladega/components";
import { GlobeIcon } from "@talladega/icons";
import useUpdateUserLanguageMutation from "@modules/user/hooks/useUpdateUserLanguageMutation";

type Props = {
  mode?: "dark" | "light";
};

const LocaleButton = ({ mode = "dark" }: Props) => {
  const router = useRouter();
  const linkLocale = getAlternateLocaleByCode(router.locale || "en");
  const useUpdateUserLanguage = useUpdateUserLanguageMutation();

  const handleLocaleChange = () => {
    router.push(router.asPath, router.asPath, { locale: linkLocale.code });
    useUpdateUserLanguage.mutate({
      locale: linkLocale.code,
      dealId: undefined, // for context, dealId is needed for tracing the tradeIn value in this centralized POST api, which roadwise doesnt need
    });
  };

  return (
    <Button
      fill="link"
      buttonStyle="borderless"
      spacing="no-padding"
      size="small"
      onClick={handleLocaleChange}
      className={mode === "dark" ? "text-white" : "text-gray-900"}
      leftIcon={<GlobeIcon className="h-6 w-6" />}
    >
      {linkLocale.code.toLocaleUpperCase()}
    </Button>
  );
};

export default LocaleButton;
